import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { useLocation } from '@reach/router'
import queryString from 'query-string'
import { CtaArrow } from 'newComponents'
import './styles.scss'

/* eslint jsx-a11y/mouse-events-have-key-events: 0 */

const Link = (props) => {
  const location = useLocation()

  const {
    children,
    className,
    activeClassName,
    to,
    title,
    style,
    target = '_blank',
    tabIndex,
    onClick = () => {},
    onMouseOver = () => {},
    onMouseOut = () => {},
    ariaLabel = '',
    ignoreQuery,
    withChevron
  } = props

  if (!to) {
    return (
      <span className={className || ''}>
        {children}
        {withChevron && <CtaArrow />}
      </span>
    )
  }

  const isExternal = (to && to.indexOf('http') !== -1) || (to && to[0] === '#')

  const launchDarklyUrl = 'https://launchdarkly.com'
  const isLaunchDarklyLink = to && to.indexOf(launchDarklyUrl) !== -1

  if (isExternal && !isLaunchDarklyLink) {
    return (
      <a
        href={to}
        className={className || ''}
        style={style}
        title={title || null}
        target={isLaunchDarklyLink ? '_self' : target}
        onClick={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        rel="nofollow noopener noreferrer"
      >
        {children}
        {withChevron && <CtaArrow />}
      </a>
    )
  }

  // Force trailing slash logic
  const relativeTo = isLaunchDarklyLink ? to.replace(launchDarklyUrl, '') : to
  const toWithTrailingSlash = `${relativeTo}${relativeTo.endsWith('/') ? '' : '/'}`

  // Handle query string logic (UTM etc)
  const toQuery = relativeTo.substring(to.indexOf('?') + 1)
  const { search: qString } = location
  const currentLocationQueryParsed = queryString.parse(qString)
  const queryStringified = queryString.stringify(currentLocationQueryParsed)

  let toWithQueries = relativeTo

  if (relativeTo.includes('?') && !qString.includes(toQuery)) {
    toWithQueries = `${relativeTo}&${queryStringified}`
  } else if (!relativeTo.includes('?') && !qString.includes(toQuery)) {
    toWithQueries = `${relativeTo}?${queryStringified}`
  } else {
    toWithQueries = `${relativeTo.substring(0, relativeTo.indexOf('?'))}?${queryStringified}`
  }

  return (
    <GatsbyLink
      to={queryStringified && !ignoreQuery ? toWithQueries : toWithTrailingSlash}
      className={className || ''}
      style={style}
      activeClassName={activeClassName || 'active'}
      title={title || null}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      tabIndex={tabIndex || 0}
      aria-label={ariaLabel}
    >
      {children}
      {withChevron && <CtaArrow />}
    </GatsbyLink>
  )
}

export default Link
